function getSessionItem<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

function isExpired(expires?: number, ttl = 0): boolean {
  const hasNoExpiry = expires === undefined;
  if (hasNoExpiry) {
    return false;
  }
  return expires + ttl < Date.now();
}

function getTourIdFromUrlParams(): string | null {
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams.get('tourId') || searchParams.get('onboardingTourId');
}

function getLinkedTourId(checkPage = false): string | null {
  const linkedTourKey = 'ONBOARDING_NEXT_TOUR';
  const item = getSessionItem<{ tourId?: string; expires?: number }>(
    linkedTourKey
  );
  if (!item || isExpired(item.expires)) {
    return null;
  }
  const [tourId, targetPageRegex] = (item.tourId || '').split(':');
  if (
    checkPage &&
    targetPageRegex &&
    !document.location.pathname.match(targetPageRegex)
  ) {
    return null;
  }
  return tourId || null;
}

function getCemMultiPagesTourId(): string | null {
  const cemMultiPagesTourKey = 'cem-multi-pages-tour';
  const ttl = 30 * 60 * 1000; // 30 mins
  const item = getSessionItem<{ id?: string; timestamp?: number }>(
    cemMultiPagesTourKey
  );
  if (isExpired(item?.timestamp, ttl)) {
    return null;
  }
  return item?.id || null;
}

export function resolveTourId(): string | null {
  return (
    getTourIdFromUrlParams() || getLinkedTourId() || getCemMultiPagesTourId()
  );
}

export function shouldRenderTour(tourId?: string | Array<string>): boolean {
  const currentTourId = getTourIdFromUrlParams() || getLinkedTourId(true);

  if (!tourId) {
    return !!currentTourId;
  }

  if (typeof tourId === 'string') {
    return currentTourId === tourId;
  }

  if (currentTourId) {
    return tourId.includes(currentTourId);
  }

  return false;
}
